import React from "react";
export const TeamColumnFormatter = (values, row) => {
  console.log('values----------->:', values)
  return values?.phoneCode + " " + values?.phone;
  // return `${IMAGE_URL}/${value}`;
}